import { call, delay, put, select, takeLatest } from "redux-saga/effects";

import iq_api_v2 from "../../../../services/iqApiV2";
import {
  GLOBAL_MEM_REQUEST,
  globalMemFailure,
  globalMemSuccess,
  LIST_GLOBAL_MEM_DOCS_REQUEST,
  LIST_GLOBAL_MEM_REQUEST,
  listGlobalMemDocsFailure,
  listGlobalMemDocsSuccess,
  listGlobalMemFailure,
  listGlobalMemRequestPlainLoad,
  listGlobalMemSuccess,
} from "../../actions/memory/globalMemoryActions";
import { bannerService } from "../../../../context/BannerContext";

async function uploadFilesAndProceed(files, userId, promptData, webUrl,fileIds,clientName,accountName,memoryType="global",opportunityId,tabs,isAdmin=0) {
  const recordIds = [];

  if (files?.length > 0 ) {
    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("document_type", "memory");
      formData.append("user_id", userId);
      if (isAdmin != null || isAdmin != undefined) {
       formData.append("is_admin", isAdmin);
      }

      try {
        const response = await iq_api_v2.post(
          "/documents/upload_file",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        const recordId = response?.data?.result?.record_id;
        if (recordId) {
          recordIds.push(recordId);
        } else {
          throw new Error("record_id not returned");
        }
      } catch (error) {
        console.error("Upload failed:", error.response?.data || error.message);
        throw error; // Optionally halt on first error
      }
    }
  }
  try {
    const formData = new FormData();
    formData.append("prompt", promptData);
    formData.append("user_id", userId);
    formData.append("client", clientName);
    formData.append("account", accountName);
    formData.append("memory_type", memoryType);
    if (tabs?.length>0) {
       formData.append("tabs", [...(tabs?.map(i=>i?.tabId))]);
    }
    if (opportunityId) {
      formData.append("opp_id", opportunityId);
    }
    if (webUrl?.length > 0 && (files?.length == 0 && fileIds?.length==0)) {
      formData.append("web_url", webUrl);
    }else{
      formData.append("web_url", "");
    }
    if (
      ((Array.isArray(recordIds) && recordIds.length > 0) || (Array.isArray(fileIds) && fileIds.length > 0)) &&
      (Array.isArray(recordIds) ? recordIds.length : 0) <= 2 ||
      Array.isArray(files) && files.length !== 0
    ) {
      formData.append("file_ids", [...recordIds,...fileIds]); // or .join(",") depending on backend expectation
    }
    else {
      formData.append("file_ids", "");
    }

    if (isAdmin!=null || isAdmin !=undefined) {
        formData.append("is_admin", isAdmin);
    }

    const finalResponse = await iq_api_v2.post(
      "build_memory/create_memory",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return finalResponse?.data;
  } catch (error) {
    console.error(
      "Final API call failed:",
      error.response?.data || error.message
    );
    throw error;
  }
}

// Worker Saga
function* fetchglobalMemSaga() {
  try {
    const payload = yield select(
      (state) => state?.globalMemDataReducer?.payload
    );
    const { files, userId, promptData, webUrl,fileIds,clientName,accountName,memoryType,opportunityId,tabs,isAdmin } = payload;
    const data = yield call(
      uploadFilesAndProceed,
      files, userId, promptData, webUrl,fileIds,clientName,accountName,memoryType,opportunityId,tabs,isAdmin
    );
    yield delay(5000)
    yield put(listGlobalMemRequestPlainLoad({userId,memoryType}));
    yield put(globalMemSuccess(data));
     yield call(
          [bannerService, bannerService.publish],
          {
            message:
            "Memory Uploaded",
            title:"Alert",
            type: 'success',
            duration: 2000
          }
        )
  } catch (error) {
    yield put(globalMemFailure(error));
  }
}

// Watcher Saga
export function* watchglobalMemSaga() {
  yield takeLatest(GLOBAL_MEM_REQUEST, fetchglobalMemSaga);
}

//-------------------------------------------------------------list memory--------------------------------------------------

async function listGlobalMem(userId,memoryType="global",opportunityId) {
  try {
    const response = await iq_api_v2.get("/build_memory/list_memories", {
      params: { user_id: userId,memory_type:memoryType,opportunity_id:opportunityId },
    });
    return response?.data?.result;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}

// Worker Saga
function* fetchlistGlobalMemSaga() {
  try {
    const payload = yield select(
      (state) => state?.listGlobalMemDataReducer?.payload
    );
    const { userId,memoryType,opportunityId } = payload;
    const data = yield call(listGlobalMem, userId,memoryType,opportunityId);
    yield put(listGlobalMemSuccess(data));
  } catch (error) {
    yield put(listGlobalMemFailure(error.message));
  }
}

// Watcher Saga
export function* watchListGlobalMemSaga() {
  yield takeLatest(LIST_GLOBAL_MEM_REQUEST, fetchlistGlobalMemSaga);
}


//-------------------------------------------------------------list files--------------------------------------------------

async function listGlobalMemDocs(userId) {
  try {
    const response = await iq_api_v2.get("/documents/list_documents", {
      params: { user_id: userId, document_type:"memory" },
    });
    return response?.data?.result;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}

// Worker Saga
function* fetchlistGlobalMemDocsSaga() {
  try {
    const payload = yield select(
      (state) => state?.listGlobalMemDataReducer?.payload
    );
    const { userId } = payload;
    const data = yield call(listGlobalMemDocs, userId);
    yield put(listGlobalMemDocsSuccess(data));
  } catch (error) {
    yield put(listGlobalMemDocsFailure(error.message));
  }
}

// Watcher Saga
export function* watchListGlobalMemDocsSaga() {
  yield takeLatest(LIST_GLOBAL_MEM_DOCS_REQUEST, fetchlistGlobalMemDocsSaga);
}
